// Prep tabs read panel directly from the URL. Keep their frame mounted when a
// tab changes; retain query remounting elsewhere until each page is audited.
export function getRouteMountKey({ pathname, search = "" }) {
  // The experimental workspace owns team/event identity and URL playback state.
  if (pathname === "/labs/youtube-workspace") return pathname;
  if (["/home","/coach","/manager"].includes(pathname)) return "home-workspace";
  if (["/team-center/prep-overview", "/team-center/prep-input"].includes(pathname)) {
    const params = new URLSearchParams(search);
    params.delete("event");
    return pathname + (params.toString() ? "?" + params.toString() : "");
  }
  if (pathname === "/my-routine") {
    const params = new URLSearchParams(search);
    params.delete("teamId");
    return pathname + (params.toString() ? "?" + params.toString() : "");
  }
  // Consuming the availability shortcut must not unmount its newly opened form.
  if (pathname === "/calendar") {
    const params = new URLSearchParams(search);
    params.delete("availabilityDraft");
    return pathname + (params.toString() ? "?" + params.toString() : "");
  }
  // Dashboard owns team identity and consumes shortcut commands. Removing those
  // commands must not remount the page or close its newly opened create form.
  if (["/team-center/dashboard","/team-center/settings"].includes(pathname)) {
    const params = new URLSearchParams(search);
    params.delete("teamId");
    params.delete("openCreateTeam");
    for (const key of ["tool","section","expectationUid","event","calendarEvent"]) params.delete(key);
    return pathname + (params.toString() ? "?" + params.toString() : "");
  }
  if (pathname !== "/team-center/prep") return pathname + search;
  const params = new URLSearchParams(search);
  // Personal drafts belong to the account; switching optional readiness teams
  // must not remount My Routine. Team panels retain their team-specific key.
  if (params.get("panel") === "my-routine") params.delete("teamId");
  params.delete("panel");
  const query = params.toString();
  return pathname + (query ? "?" + query : "");
}
